import type { ReferencesContextValue } from "./ReferencesContextValue"

export const defaultReferencesContextValue: ReferencesContextValue = {
  containerElementRef: { current: null },
  listElementRef: { current: null },
}
